import { useMutation } from 'react-query';

import { makePerformSocialLoginUseCase } from 'modules/authentication/domain/useCases';
import { useAuth } from 'modules/authentication/presentation/contexts';
import {
  TRoutePathsWithParams,
  useNavigation,
  useRouteQuery,
} from 'shared/presentation/contexts';
import { useRequestErrorHandler } from 'shared/presentation/hooks';

export default function useSocialLogin() {
  const navigation = useNavigation();
  const { origin } = useRouteQuery<'/login'>();
  const auth = useAuth();
  const { handleError } = useRequestErrorHandler('authentication');

  const mutation = useMutation(
    () => makePerformSocialLoginUseCase().execute(),
    {
      onSuccess: session => {
        auth.login(session);

        if (origin) navigation.push(decodeURI(origin) as TRoutePathsWithParams);
      },
      onError: error => handleError(error),
    },
  );

  return { loading: mutation.isLoading, login: mutation.mutateAsync };
}
